import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const MontoExtranjeroFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MONTO EXTRANJERO' htmlFor='input-modalavanz-montoExtranjero' md={12} />
      <Col md={12}>
        <Field name='montoExtranjero'>
          {({ field }) => (
            <Form.InputNumber {...field} id='input-modalavanz-montoExtranjero' isInvalid={iTouched && iError} disabled={fIsSubmitting} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoExtranjeroFormGroup)
